import { FC } from 'react'

const MastercardIcon: FC = () => (
  <svg
    width="41"
    height="26"
    viewBox="0 0 41 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="41"
      height="25"
      rx="5"
      fill="black"
    />
    <path
      d="M17.5547 7.88281H23.559V18.8888H17.5547V7.88281Z"
      fill="#FF5F00"
    />
    <path
      d="M17.9356 13.3907C17.9319 12.3355 18.1654 11.2929 18.619 10.3401C19.0726 9.38727 19.7346 8.54864 20.5561 7.88622C17.743 5.63169 13.7033 5.96014 11.2744 8.64144C8.84552 11.3227 8.84654 15.4567 11.2744 18.138C13.7023 20.8193 17.742 21.1478 20.5561 18.8922C19.735 18.2301 19.0733 17.392 18.6197 16.4397C18.1661 15.4875 17.9323 14.4455 17.9356 13.3907Z"
      fill="#EB001B"
    />
    <path
      d="M31.658 13.3915C31.658 16.0707 30.1577 18.5148 27.7957 19.6867C25.4337 20.8586 22.6207 20.5494 20.5547 18.8929C21.3756 18.2304 22.0374 17.3921 22.4913 16.4397C22.9452 15.4874 23.1796 14.4454 23.1772 13.3904C23.1772 11.2434 22.2101 9.21389 20.5547 7.88692C22.6207 6.23151 25.4307 5.92334 27.7947 7.09419C30.1587 8.26504 31.658 10.7091 31.658 13.3894V13.3915Z"
      fill="#F79E1B"
    />
  </svg>
)

export default MastercardIcon
